<template>
  <v-menu
    offset-y
    left
    nudge-bottom="8"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        :content="unreadCount"
        :value="unreadCount > 0"
        color="red"
        overlap
        bordered
      >
        <v-btn icon v-bind="attrs" v-on="on" :title="'Notifications'">
          <v-icon>mdi-bell</v-icon>
        </v-btn>
      </v-badge>
    </template>
    <v-card max-width="420">
      <v-card-title class="py-2 px-3 d-flex align-center">
        <span class="mr-2">Notifications</span>
        <v-spacer />
        <v-btn small text @click="markAllRead" :disabled="unreadCount === 0">Mark all read</v-btn>
        <v-btn small text color="error" @click="clearAll" :disabled="history.length === 0">Clear</v-btn>
      </v-card-title>
      <v-divider />
      <v-list dense two-line>
        <template v-if="history.length">
          <v-list-item
            v-for="n in history"
            :key="n.id"
          >
            <v-list-item-avatar>
              <v-avatar size="20" :color="typeColor(n)">
                <span></span>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="n.text" />
              <v-list-item-subtitle v-text="formatDate(n.date)" />
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon small @click="remove(n.id)" :title="'Remove'">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>No notifications</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { notifyStore, markAllRead, clearAllNotifications, removeNotificationById } from '../../plugins/notify'

export default {
  name: 'NotificationBell',
  data () {
    return {
      store: notifyStore
    }
  },
  computed: {
    unreadCount () {
      return this.store.unreadCount
    },
    history () {
      return this.store.history
    }
  },
  methods: {
    markAllRead () {
      markAllRead()
    },
    clearAll () {
      clearAllNotifications()
    },
    remove (id) {
      removeNotificationById(id)
    },
    typeColor (n) {
      switch (n.type) {
        case 'success': return 'green darken-1'
        case 'error': return 'red darken-2'
        case 'warning': return 'orange darken-2'
        default: return 'blue darken-1'
      }
    },
    formatDate (date) {
      try {
        const d = (date instanceof Date) ? date : new Date(date)
        return d.toLocaleString()
      } catch (e) {
        return ''
      }
    }
  }
}
</script>


